import { render, staticRenderFns } from "./StokEkstreResim.vue?vue&type=template&id=cca526de&"
import script from "./StokEkstreResim.vue?vue&type=script&lang=js&"
export * from "./StokEkstreResim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports